import { h } from "preact";

import { classNames } from "../helpers";
import Checkbox from "./Checkbox.jsx";
import ListItem from "./ListItem.jsx";

export default function CheckboxGroup(props) {
  return (
    <div
      class={classNames(
        "checkbox-group",
        props.class,
        props.wide && "checkbox-group--wide"
      )}
      id={props.id}
    >
      {props.items.map(({ value, label, description, iconFront, iconBack }) => (
        <ListItem
          secondLine={description}
          iconBack={iconBack}
          iconFront={
            <Checkbox
              class={classNames("checkbox-group__item")}
              value={value}
              name={props.name}
              checked={props.value.includes(value)}
              onChange={props.onChange}
            ></Checkbox>
          }
        >
          {label}
        </ListItem>
      ))}
    </div>
  );
}
